import React, { useEffect } from "react";
import AnimationCommon from "../common/AnimationCommon";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { Link } from "react-router-dom";

const SignIn = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");
  }, []);

  return (
    <section className='auth-page'>
      <AnimationCommon />
      <div className='auth-card'>
        <div className='text-center'>
          <h2>Sign In</h2>
          <img src='assets/images/title-line.png' alt='title-line' className='img-fluid line' />
          <p>Welcome To chatloop, Please Sign in With Your Personal Account Information.</p>
        </div>
        <div className='main'>
          <Form className='auth-form'>
            <FormGroup className='form-group'>
              <Label>Email</Label>
              <FaEnvelope className='icon-setting' />
              <Input required='' name='login[username]' type='email' placeholder='Email' />
            </FormGroup>
            <div className='form-group'>
              <Label>Password</Label>               
              <FaLock className='icon-setting' />
              <Input required='' name='login[password]' type='password' placeholder='Password' />
              <Link to={`${process.env.PUBLIC_URL}/forget-password`} className='text-decoration-none forgot-pass'>forgot?</Link>
            </div>
            <FormGroup>
              <Button color="" className='submit'>Sign in</Button>
            </FormGroup>
            <div className='or-saparator'>
              <span>or</span>
            </div>
            <h6 className='text-center mt-0 mb-3'>Sign in with:</h6>
            <div className='form-button d-sm-flex justify-content-center align-items-center text-center social-btns'>
              <Button color="" className='submit fb'>Facebook</Button>
              <button color="" className='submit ggl'>Google</button>
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default SignIn;
